import { IUserDetail, IUserSetting } from 'src/services/types'
import { ProfileImages } from '../UsersToValidate/ProfileImages'

interface IUserDetailProps {
    user: IUserDetail
}
export const DetailsUserInformation = ({ user }: IUserDetailProps) => {
  return (
    <div className='row'>
        <div className='col-sm-6 col-lg-4 col-xl-3'>
            <h6 className='text-primary'>Full Name:</h6>
            <p>{user?.firstName} {user?.lastName}</p>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3'>
            <h6 className='text-primary'>Email:</h6>
            <p>{user?.email}</p>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3'>
            <h6 className='text-primary'>Active:</h6>
            <p>{user?.active ? 'Yes' : 'No'}</p>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3'>
            <h6 className='text-primary'>Goal:</h6>
            <p>{user?.goal}</p>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3'>
            <h6 className='text-primary'>User Type:</h6>
            <p>{user?.userType}</p>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3'>
            <h6 className='text-primary'>Age:</h6>
            <p>{user?.profile?.age}</p>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3'>
            <h6 className='text-primary'>Created At:</h6>
            <p>{user?.created_at}</p>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3'>
            <LabelBadge 
                label='Sex'
                isVisible={!!user?.profile?.isSexVisible}
            />
            <p>{user?.profile?.sexDescription}</p>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3'>
            <LabelBadge 
                label='Sexual Orientation'
                isVisible={!!user?.profile?.isSexualOrientationVisible}
            />
            <p>{user?.profile?.sexualOrientation ?? '-'}</p>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3 mb-2'>
            <h6 className='text-primary'>Verified for PLAID:</h6>
            <span 
                className='px-3 py-1 rounded' 
                style={{backgroundColor: user?.isVerified === null ? '#e6e7e8' : ( user?.isVerified ? '#d4f2d5' : '#f8e2e2' )}}
            > {user?.isVerified === null ? 'Not started' : (user?.isVerified ? 'Yes' : 'No')} </span>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3'>
            <h6 className='text-primary'>Verified for ADMIN:</h6>
            <span 
                className='px-3 py-1 rounded' 
                style={{backgroundColor: user?.isVerifiedByAdmin ? '#d4f2d5' : '#f8e2e2' }}
            > {user?.isVerifiedByAdmin ? 'Yes' : 'No'} </span>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3'>
            <h6 className='text-primary'>Birthdate</h6>
            <p>{user?.birthDate || '-'}</p>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3'>
            <h6 className='text-primary'>Phone Number:</h6>
            <p>{user?.profile?.phoneNumber || '-'}</p>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3'>
            <h6 className='text-primary'>Address:</h6>
            <p>{user?.profile?.address || '-'}</p>
        </div>
        <div className='col-sm-6 col-lg-4 col-xl-3 mb-2'>
            <h6 className='text-primary'>Group:</h6>
            <span 
                className='px-3 py-1 rounded' 
                style={{backgroundColor: user?.group?.color || 'transparent' }}
            > {user?.group?.name ?? '-'} </span>
        </div>
        
        <SettingsSection 
            settings={user?.settings || []}
        />

        <div className='col-sm-12 col-xs-12 col-lg-6'>
            <h6 className='text-primary'>About me:</h6>
            <p>{user?.profile?.aboutMe || '-'}</p>
        </div>
        <div className='col-sm-12 col-xs-12 col-lg-6'>
            <h6 className='text-primary'>Note:</h6>
            <p>{user?.note || '-'}</p>
        </div>
        <div className='col-sm-12 mb-4'>
            <h6 className='text-primary'>Prompts:</h6>
            <div className='d-flex flex-wrap'>
            {
                (Array.isArray(user?.prompts) && user?.prompts.length > 0) ? 
                user?.prompts.map((prompt, index) => (
                    <span key={index} className='mb-1 me-2' style={{backgroundColor: '#f5f5f5', padding: '3px 10px', borderRadius: '5px'}}>
                        <span className='text-secondary'> - {prompt?.title}</span>
                        <span style={{marginLeft: '5px'}}>{prompt?.text}</span>
                    </span>
                )) : 
                <p>No prompts available</p>
            }
            </div>
        </div>
        <div className='col-sm-12'>
            <div className='row mb-3'>
                <h6 className='text-primary'>Images:</h6>
            </div>
            <ProfileImages images={[user?.profile?.imagePath || ''].concat( Array.isArray(user?.images) ? user?.images.map(img => img.path) : [])}  />
        </div>
    </div>
  )
}

const LabelBadge = ({ label, isVisible }: { label: string, isVisible: boolean | undefined }) => {
  return (
    <div className='d-flex align-items-center mb-1 gap-2'>
        <h6 className='text-primary m-0'>{label}:</h6>
        <small 
            className={'px-1 rounded ' + (isVisible === undefined ? '' : (isVisible ? 'text-info' : 'text-danger'))} 
            style={{backgroundColor: isVisible === undefined ? '#e6e7e8' : ( isVisible ? '#def0ff' : '#f8e2e2'), fontSize: '0.7rem'}}
        > 
            {isVisible === undefined ? 'incomplete' : (isVisible ? 'Visible' : 'Not Visible')}
        </small>
    </div>
  )
}

const SettingsSection = ({ settings }: { settings: IUserSetting[] }) => {

    const getDataSetting = (key: string) => {
        let isVisible: boolean | undefined = undefined;
        let value = '-';
        const settingsAux = settings.filter(s => s?.settingType?.name === key);
        if (settingsAux.length === 0) return { isVisible: undefined, value: '-' };
        if(settingsAux.length === 1) {
            isVisible = settingsAux[0]?.settingType?.isVisible;
            value = (settingsAux[0]?.text && !['Height', 'Weight'].includes(settingsAux[0]?.text)) ? settingsAux[0]?.text : (settingsAux[0]?.value ? (settingsAux[0]?.value + ' ' + settingsAux[0]?.unitMeasure) : '-');
        } else if (settingsAux.length > 1) {
            isVisible = settingsAux[0]?.settingType?.isVisible;
            value = settingsAux.map(s => s?.text || '-').join(', ');
        }
        return {
            isVisible,
            value
        };
    }

    const arraySettings = [
        {
            key: 'ethnicity',
            label: 'Ethnicity'
        },
        {
            key: 'height',
            label: 'Height'
        },
        {
            key: 'weight',
            label: 'Weight'
        },
        {
            key: 'bodyType',
            label: 'Body Type'
        },
        {
            key: 'occupation',
            label: 'Occupation'
        },
        {
            key: 'experienceLevel',
            label: 'Experience Level'
        },
        {
            key: 'religiousPerson',
            label: 'Religious Person'
        },
        {
            key: 'haveKids',
            label: 'Have Kids'
        },
        {
            key: 'arePetsDealBreaker',
            label: 'Are Pets Deal Breaker'
        },
        {
            key: 'havePet',
            label: 'Have Pet'
        },
        {
            key: 'yearlySalary',
            label: 'Yearly Salary'
        },
        {
            key: 'interests',
            label: 'Interests'
        },
        {
            key: 'traitsToDescribeUser',
            label: 'Traits to Describe User'
        }
    ];

    return (
        <>
            {
                arraySettings.map((setting, index) => {
                    const settingData = getDataSetting(setting.key);
                    return (
                        <div className='col-sm-6 col-lg-4 col-xl-3' key={index}>
                            <LabelBadge 
                                label={setting.label}
                                isVisible={ settingData?.isVisible }
                            />
                            <p>{ settingData?.value }</p>
                        </div>
                    )
                })
                    
            }
        </>
    )
}